import React from 'react';
import useNav from '../../../hooks/useNav';
import { RouteId } from 'types/frontend_models/navigation/RouteId';
import { SafetyOutlined, CloudServerOutlined, HeartOutlined } from '@ant-design/icons';

function Dashboard()
{
    useNav({ routeId: RouteId.home });
    return (
        <div className="home-content-container">
            <div className="home-background-container">
                <div className="home-background-filler"></div>
                <svg xmlns="http://www.w3.org/2000/svg" className="home-background-svg" viewBox="0 0 1216.14 259.66" preserveAspectRatio="xMidYMid meet">
                    <title>background</title>
                    <path className="home-background-svg-path" d="M1216.14,0H0C158.48,150.35,380.59,303.34,608.32,242.59c217.16-57.93,406.15-99.92,607.82,17.07" />
                </svg>
            </div>
            <h1 className="home-header txt-center txt-bold">Welcome to <span className="txt-main-color">My</span>APTEC</h1>
            <div className="home-subheader-text-container">
                <p className="txt-center txt-larger">MyAPTEC allows you to keep track of your orders, deliveries, ordered products and all related documents, like IFU’s, applications, lot details, and QC documents.</p>
            </div>
            <div className="home-cards-container row">
                <div className="home-card col-12 col-m-6 col-xl-4">
                    <div className="home-card__container elevated-container txt-center">
                        <div className="home-card__icon-container pos-abs">
                            {/* <LikeOutlined className="mgx-auto home-card-icon" /> */}
                            {/* <SmileOutlined className="mgx-auto home-card-icon" /> */}
                            <HeartOutlined className="mgx-auto home-card-icon" />
                        </div>
                        <div className="home-card__text-container pos-abs">
                            <h2 className="home-card__header">Easy to use</h2>
                            <p className="txt-larger">Easy to enter, easy to navigate and quick to attain all the needed.</p>
                        </div>
                    </div>
                </div>
                <div className="home-card col-12 col-m-6 col-xl-4">
                    <div className="home-card__container elevated-container txt-center">
                        <div className="home-card__icon-container pos-abs">
                            {/* <ForkOutlined className="mgx-auto home-card-icon" /> */}
                            {/* <DatabaseOutlined className="mgx-auto home-card-icon" /> */}
                            <CloudServerOutlined className="mgx-auto home-card-icon" />
                            {/* <CloudOutlined className="mgx-auto home-card-icon" /> */}
                            {/* <WifiOutlined className="mgx-auto home-card-icon" /> */}
                        </div>
                        <div className="home-card__text-container pos-abs">
                            <h2 className="home-card__header">Always available</h2>
                            <p className="txt-larger">No need to browse endless email trails nor print various documents, no matter where you are or when you need them.</p>
                        </div>
                    </div>
                </div>
                <div className="home-card col-12 col-m-6 col-xl-4">
                    <div className="home-card__container elevated-container txt-center">
                        <div className="home-card__icon-container pos-abs">
                            <SafetyOutlined className="mgx-auto home-card-icon" />
                        </div>
                        <div className="home-card__text-container pos-abs">
                            <h2 className="home-card__header">Safe</h2>
                            <p className="txt-larger">MyAPTEC is available for everyone in your organization with a valid ID, saving valuable communication time.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="txt-larger txt-center home-bottom-text">
                <span>Need help? Contact us at </span><a href="mailto:info@aptec.be">info@aptec.be</a>
            </div>

        </div>
    );
}

export default Dashboard;